import React from "react";

function AnnexesLegal() {
  return (
    <section>
      <p>
        Le site Le Média est édité par Le Média, SCIC au capital social de
        28&nbsp;128€ — RCS &nbsp;880&nbsp;234&nbsp;471&nbsp; — APE 5911A — 242
        bd Voltaire 75011 Paris.
      </p>
      <p>
        <strong>Directeur de publication&nbsp;:&nbsp;</strong>
        Diego Siaud
        <br />
        <strong>Numéro CPPAP&nbsp;:&nbsp;</strong>0322 Y 94203
        <br />
        <strong>ISSN&nbsp;:&nbsp;</strong>
        2608-5798
      </p>
      <h2>Contact</h2>
      <p>
        Nous contacter&nbsp;:&nbsp;contact@lemediatv.fr.
        <br />
        Nous écrire&nbsp;:&nbsp;Le Média, 242 boulevard Voltaire – 75011 Paris.
        <br />
        Nous téléphoner&nbsp;:&nbsp;07 57 18 86 39.
      </p>
      <h2>Comité d'éthique</h2>
      <p>
        Un comité d’éthique est constitué auprès de la société afin de
        contribuer au respect du principe de pluralisme. Ce comité est composé
        de personnalités indépendantes de la société éditrice et des sociétés
        qui la contrôlent directement ou indirectement. L’Autorité est tenue
        informée de toute modification qui serait apportée à sa composition. Le
        comité établit un bilan annuel communiqué à l’Autorité. Il peut se
        saisir ou être consulté à tout moment par les organes dirigeants de la
        personne morale, par le médiateur lorsqu'il existe ou par toute
        personne. Il peut être contacté via l'adresse{" "}
        <a href="mailto:comite-ethique@lemediatv.fr">
          comite-ethique@lemediatv.fr
        </a>
        .
      </p>
      <ul>
        <li>
          <strong>Rony Brauman</strong> est un médecin spécialisé en pathologie
          tropicale. Président de Médecins Sans Frontières de 1982 à 1994, il
          enseigne au Humanitarian and Conflict Response Institute (HCRI) et il
          est chroniqueur à Alternatives Economiques.
        </li>
        <li>
          <strong>Bernard Friot</strong> est sociologue et économiste,
          professeur émérite à l'université Paris-Nanterre, auteur de nombreux
          ouvrages sur la Sécurité sociale et le salariat.
        </li>
        <li>
          <strong>Anne-Sophie Simpere</strong> est juriste en droit
          international et communicante de formation, elle a travaillé pour des
          ONG comme Amnesty International et Les Amis de la Terre, Greenpeace,
          Bankwatch et Samat mais aussi comme journaliste (Basta!, Revue
          Dessinée).
        </li>
        <li>
          <strong>Louis-Georges Tin</strong> est universitaire français et
          militant contre l'homophobie et le racisme. Président du Conseil
          Représentatif des Associations Noires de France (CRAN) de 2011 à 2017.
        </li>
        <li>
          <strong>Youlie Yamamoto</strong> est porte-parole de l’ONG Attac et
          cofondatrice du collectif Les Rosies. Elle est une activiste féministe
          pour la justice sociale fiscale et climatique.
        </li>
      </ul>
      <h2>Propriété intellectuelle</h2>
      <p>
        Le site www.lemediatv.fr est protégé par la législation en vigueur sur
        les droits de propriété intellectuelle et les conventions
        internationales applicables. Toute reproduction non autorisée est
        passible de poursuite pour contrefaçon.
      </p>
      <h2>Hébergement du site</h2>
      <p>
        <a
          href="https://www.octopuce.fr/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Octopuce SARL
        </a>{" "}
        - 25, rue Popincourt, 75011 PARIS (09 72 44 29 15)
      </p>
      <h2>Nom de domaine</h2>
      <p>
        1&1 Internet est le prestataire d’enregistrement du nom de domaine
        lemediatv.fr. La société 1&1 Internet est une SARL au capital de
        100&nbsp;000€ immatriculée au RCS de Sarreguemines sous le n° 431 303
        775 – siège social est situé 7, place de la Gare 57200 Sarreguemines.
      </p>
    </section>
  );
}

export default AnnexesLegal;
